import { Form } from "antd";

import { ContactSelect } from "components/selects/contact-select";
import { useOnChange } from "hooks/use-on-change";
import { useSetVendorContacts } from "data/use-vendors";
import { ContactDetailsModal } from "../../../components/modals/contact-details-modal";
import { useModal } from "../../../hooks/use-modal";
import { Modal } from "../../../components/modal";

export const SetContacts = ({ close, isOpen, vendor }) => {
  const setVendorContacts = useSetVendorContacts({
    onSuccess: close,
  });

  const { modal: contactDetailsModal, open: openContactDetailsModal } =
    useModal(ContactDetailsModal);

  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setVendorContacts.mutate({
      id: vendor._id,
      contactIds: values.contactIds,
    });
  };

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        contactIds: vendor.contacts,
      });
    },
    [isOpen, form, vendor]
  );

  return (
    <>
      {contactDetailsModal}
      <Modal
        confirmLoading={setVendorContacts.isLoading}
        okText="Set Contacts"
        onCancel={close}
        onOk={form.submit}
        title="Contacts"
        open={isOpen}
      >
        <Form
          form={form}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          onFinish={onFinish}
        >
          <ContactSelect
            label="Contacts"
            mode="multiple"
            name="contactIds"
            placeholder="Select contacts"
            extra={
              <div style={{ marginTop: "8px" }}>
                <a
                  onClick={() =>
                    openContactDetailsModal({
                      disableRelationshipSelect: true,
                      onCreate: (contact) => {
                        const current = form.getFieldValue("contactIds");

                        form.setFieldValue("contactIds", [
                          ...current,
                          contact._id,
                        ]);
                      },
                    })
                  }
                >
                  Create
                </a>{" "}
                a new contact
              </div>
            }
          />
        </Form>
      </Modal>
    </>
  );
};
